export default __webpack_public_path__ + "static/media/menu-banner-04.f3b0d611.jpg";